import { BsDot } from "react-icons/bs";

export default function PageTitle({ title, path }) {
  return (
    <div className="h-56 w-full bg-[#F6F5FF]">
      <div className="mx-auto max-w-5xl px-10 flex flex-col justify-center h-full">
        <h1 className="text-4xl mb-3 font-bold font-fontOne">{title}</h1>
        <p className="text-sm font-semibold">
          <span>{path[0]}</span>
          <BsDot className="inline-block" />
          <span className="text-pink">{path[1]}</span>
        </p>
      </div>
    </div>
  );
}
